export interface PurchasedItem {
  id: string;
  name: string;
  price: number;
  quantity: number;
  imageUrl: string;
}

export enum ProviderEnum {
  STRIPE = 'stripe',
  ADYEN = 'adyen',
  BRAINTREE = 'braintree',
  NUVEI = 'nuvei',
  PAYPAL = 'paypal',
}

export type ExcludeOtherPaymentMethod = Exclude<PaymentMethodEnum, PaymentMethodEnum.OTHER>;

export enum CardType {
  VISA = 'visa',
  MASTERCARD = 'mastercard',
  AMEX = 'amex',
  DISCOVER = 'discover',
  DINERS = 'diners',
}

export enum Templates {
  Default = 'default',
  OnePayment = 'ONE_PAYMENT',
}

export enum DeviceType {
  ANDROID = 'android',
  IOS = 'ios',
  WEB = 'web',
}

export enum PaymentMethodEnum {
  CREDIT_CARD = 'card',
  APPLE_PAY = 'apple',
  GOOGLE_PAY = 'google',
  OTHER = 'other',
  PAYPAL = 'paypal',
  CASH_APP = 'cashapp',
  KLARNA = 'klarna',
  LINK = 'link',
  UNIONPAY = 'unionpay',
  VERIFON = 'verifone',
  AMAZON_PAY = 'amazon_pay',
  VENMO = 'venmo',
  AFTERPAY = 'afterpay',
  IDEAL = 'ideal',
  AFFIRM = 'affirm',
  PIX = 'apmgw_PIX',
  NEOSURF = 'apmgw_Neosurf',
  BLIK = 'blik',
  BLIK_CHECKOUT = 'blik_checkout',
  P24 = 'p24',
  TRUSTLY = 'apmgw_Trustly',
  EPS = 'eps',
  BANCONTACT = 'bancontact',
  ALIPAY = 'alipay_hk',
  PAYME = 'payme',
  NUVEI_NEOSURF = 'apmgw_NeoSurf_Direct_Integration_',
  SCALA_PAY = 'scalapay',
}
